var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-img',_vm._b({staticClass:"inst-icons",attrs:{"src":_vm.instIcons[_vm.instAT],"rounded":"0"}},'b-img',_vm.thumbnailProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }